<template>
  <div class="main-container">
    <iframe :src="url" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      '2.0': 'https://kdocs.cn/l/cehZx0vG5W7f',
      '3.0': 'https://ucnu9t4fowy8.feishu.cn/wiki/Jr8MwN6SniPn4KkrVQ6cbgMCnmc',
    }
  },
  computed: {
    url() {
      return this[this.$route.query.v]
    },
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.main-container {
  width: 100%;
  height: 100vh;
  padding-bottom: 10px;
  margin-top: 68px;
}
</style>
